/** Стиль строки-кнопки: вся строка кликабельна, разделитель снизу.
 *
 * Вынесено после живого бага: у `<button>` есть своя граница по умолчанию —
 * 3px `currentColor`, то есть белая. Написать `border: "none"` ПОСЛЕ
 * `borderBottom` значит затереть его шорткатом, а вернуть потом только
 * `borderBottomStyle` — получить ту самую белую полосу во всю строку.
 *
 * Порядок здесь зафиксирован раз и навсегда: сначала снимаем границу целиком,
 * потом ставим нижнюю.
 */
export function rowButton(last: boolean): React.CSSProperties {
  return {
    display: "flex",
    alignItems: "center",
    gap: "var(--s-3)",
    width: "100%",
    minHeight: "var(--tap)",
    padding: "13px 0",
    background: "none",
    font: "inherit",
    color: "inherit",
    cursor: "pointer",
    textAlign: "left",
    border: "none",
    borderBottom: last ? "none" : "1px solid var(--separator)",
  };
}
